import * as React from 'react';
import * as styles from './Projects.css';
import { Responsive } from '@cian/ui-kit';

interface IProjectsProps {
  title: React.ReactNode;
  tabs: React.ReactNode;
  viewMode: React.ReactNode;
  filters: React.ReactNode;
  content: React.ReactNode;
}

export function Projects({ tabs, viewMode, title, filters, content }: IProjectsProps) {
  return (
    <section id="projects" className={styles['wrapper']}>
      <div className={styles['title']}>{title}</div>

      <Responsive desktop>
        <div className={styles['controls']}>
          {tabs}
          {viewMode}
        </div>

        <div className={styles['filters']}>{filters}</div>
      </Responsive>

      {content}
    </section>
  );
}
